// extracted by mini-css-extract-plugin
module.exports = {"container":"GiveBlock_container__WB8tq","button":"GiveBlock_button__Wvc3P"};